import { createRouter, createWebHistory } from 'vue-router'

// 假设项目的基础路径为空字符串，可根据实际情况修改
const baseUrl = ''

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/ticket-list/'
    },
    {
      path: '/ticket-list/',
      name: 'TicketList',
      meta: {
        isMicroPage: true
      },
      component: () => import('@/views/ticket/List.vue')
    },
    {
      path: '/create-ticket/',
      name: 'CreateTicket',
      meta: {
        isMicroPage: true
      },
      component: () => import('@/views/ticket/Create.vue')
    },
    {
      path: '/ticket-:ticket_id/',
      meta: {
        isMicroPage: true
      },
      component: () => import('@/views/ticket/Detail.vue')
    },
    {
      path: '/request-refund/',
      name: 'Refund',
      meta: {
        isMicroPage: true
      },
      component: () => import('@/views/Refund.vue')
    },
    {
      path: '/contact-form/',
      name: 'Contact',
      meta: {
        isMicroPage: true
      },
      component: () => import('@/views/Contact.vue')
    },
    {
      path: '/temp-ticket/',
      name: 'TemporaryTicket',
      component: () => import('@/views/ticket/temporary.vue')
    },
    {
      path: '/review/',
      name: 'Review',
      component: () => import('@/views/Review.vue')
    },
    // 404 页面
    {
      path: '/:pathMatch(.*)*',
      redirect: '/ticket-list/'
    }
  ]
})

// 路由守卫
// router.beforeEach((to, from, next) => {
//   // 设置页面标题
//   document.title = `${to.meta.title || '用户中心'} - 工单系统`
//   next()
// })

export default router
